
import { Section } from "./data-types";

export const StudyPrimary: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Primary Education",
						content: () => [
							<p>
								Primary school geography in Ireland focuses on developing skills and concepts through the study
								of local and global environments, and is taught through
								the <a href="https://www.curriculumonline.ie/getmedia/346522bd-f9f6-49ce-9676-49b59fdb5505/psec03c_science_curriculum.pdf">Social, Environmental and Scientific Education (SESE)</a> strand.
								Students learn about geography through exploring their locality, using maps,
								and investigating local issues. Key objectives include developing a sense of place,
								understanding human and natural environments, and fostering a respect for the world around them.
							</p>,
							<p>
								Key concepts and skills:
							</p>,
							<ul>
								<li>Sense of place and space</li>
								<li>Mapping and graphical skills</li>
								<li>Geographical investigation</li>
								<li>Local environments</li>
								<li>Wider world and global issues</li>
								<li>Environmental awareness</li>
							</ul>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/7.jpg"
						},
					},
				}
			]
		}
	]
}
